import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const ranTrades: SeasonTrades[] = [
  {
    season: "2009/10",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "David West",
        gotInReturn: "OJ Mayo",
      },
    ],
  },
  {
    season: "2011/12",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Kyrie Irving",
        gotInReturn: "Dorell Wright and DJ Augustin",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Russell Westbrook",
        gotInReturn: "Steve Nash and Andrew Bogut",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Dirk Nowitzki and Steve Nash",
        gotInReturn: "Carmelo Anthony",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Carlos Boozer",
        gotInReturn: "Jarrett Jack",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Joakim Noah, David West and Dorell Wright",
        gotInReturn: "Chris Bosh and Kyle Korver",
      },
    ],
  },
];
